module.exports = __webpack_public_path__ + "static/media/Electric.cbaf6a20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Electric.jpg
// module id = 21
// module chunks = 0